export const SHIPMENT_REJECTION_TYPES_FETCHED = 'SHIPMENT_REJECTION_TYPES_FETCHED';
export const SHIPMENT_REJECTION_TYPE_ADDED = 'SHIPMENT_REJECTION_TYPE_ADDED';
export const SHIPMENT_REJECTION_TYPE_UPDATE = 'SHIPMENT_REJECTION_TYPE_UPDATE';
